export const columns = [
  'Invoice id',
  'Project name',
  'Amount',
  'Due date',
  'Paid on',
  'Days paid after past due',
];

export enum InvoiceState {
  OVERDUE = 'OVERDUE',
  PAIDAFTERDUE = 'PAIDAFTERDUE',
  PAID = 'PAID',
  OPEN = 'OPEN',
  ALL = 'ALL',
}

export const InvoiceStateLabel = {
  [InvoiceState.OVERDUE]: 'Overdue',
  [InvoiceState.PAIDAFTERDUE]: 'Paid after due',
  [InvoiceState.OPEN]: 'Open',
  [InvoiceState.PAID]: 'Paid',
  [InvoiceState.ALL]: 'All',
};
